import React from 'react'
import {
  Text,
  InjectedModalProps,
  Flex,
  Grid,
  Image,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  Heading,
  CloseIcon,
  IconButton,
  ModalBody,
} from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { useTheme } from 'styled-components'

const StyledImg = styled.img`
  width: 273px;
  height: auto;

  ${({ theme }) => theme.mediaQueries.md} {
    width: 360px;
  }
`
const StarImage = styled(Image)`
  min-width: 24px;
  min-height: 24px;
`
const GridCell = styled(Grid)`
  justify-self: start;
`
const StyledModalCloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 10px;
`
const StyledModalContainer = styled(ModalContainer)`
  max-height: 90vh;

  ${({ theme }) => theme.mediaQueries.xs} {
    max-width: 95%;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    max-width: 970px;
  }
`

const StyledModalBody = styled(ModalBody)`
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
  }
`

const ProductGuideModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const diamondImage = isDark ? '/images/xVVS/white-diamond.svg' : '/images/darkPurpleVector.svg'
  const guideImage = isDark ? '/images/xVVS/xvvs-graph-dark.png' : '/images/xVVS/xvvs-graph.png'

  return (
    <StyledModalContainer minWidth="360px">
      <ModalHeader>
        <ModalTitle flexDirection="column">
          <Heading ml={0} width="100%">
            {t('xVVS Product Guide')}
          </Heading>
          <Text ml={0} mt={2} fontSize="13px" width="100%">
            {t('Lock your xVVS to boost your earnings. Farm rewards with no impermanent loss!')}
          </Text>
        </ModalTitle>
        <StyledModalCloseButton>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon fill="text" />
          </IconButton>
        </StyledModalCloseButton>
      </ModalHeader>
      <StyledModalBody pb={['150px', '150px', '50px', null, null, null]} px="15px">
        <Flex justifyContent="center">
          <StyledImg alt="vault mole" src={guideImage} />
        </Flex>
        <Flex mb={['0', '0', '80px', '0', '0']}>
          <Grid
            gridTemplateColumns="50px 1fr"
            gridTemplateRows={[
              'repeat(3, 1fr)',
              'repeat(3, 1fr)',
              'repeat(3, 1fr)',
              'repeat(3, 130px)',
              'repeat(3, 130px)',
            ]}
            alignContent="center"
            gridRowGap={['20px', '20px', '20px', '0', '0']}
          >
            <GridCell>
              <StarImage width={24} height={24} alt="star" src={diamondImage} />
            </GridCell>
            <GridCell>
              <Flex flexDirection="column">
                <Text bold>{t('Step 1 - Stake VVS tokens for xVVS')}</Text>
                <Text small color="textSubtle" maxWidth="480px">
                  {t(
                    'xVVS is a non-tradable, yield bearing token. Automatically receive a share of VVS platform profits!',
                  )}
                </Text>
              </Flex>
            </GridCell>
            <GridCell>
              <StarImage width={24} height={24} alt="star" src={diamondImage} />
            </GridCell>
            <GridCell>
              <Flex flexDirection="column">
                <Text bold>{t('Step 2 - Lock your xVVS to maximize your earnings')}</Text>
                <Text small color="textSubtle" maxWidth="480px">
                  {t('Flexible locking period to suit your investment strategy. Stack your earning potential!')}
                </Text>
              </Flex>
            </GridCell>
            <GridCell>
              <StarImage width={24} height={24} alt="star" src={diamondImage} />
            </GridCell>
            <GridCell>
              <Flex flexDirection="column">
                <Text bold>{t('Step 3 - Compound your earnings')}</Text>
                <Text small color="textSubtle" maxWidth="480px">
                  {t(
                    'xVVS vaults issue VVS rewards based on your vault holdings. Harvest your rewards and compound back into xVVS!',
                  )}
                </Text>
              </Flex>
            </GridCell>
          </Grid>
        </Flex>
      </StyledModalBody>
    </StyledModalContainer>
  )
}

export default ProductGuideModal
